import request from 'sb-request'
// import requestNew from 'sb-request-new'
import { reducers } from 'redux/core'
import { array } from 'common/helpers'


// TODO: Ask backends to move that logic to EXTRAS product feed
const processBreastCancerItem = (products) => {
  const breastCancerItemNameRegExp = /fierce pink/
  const breastCancerItemIndex = products.findIndex((product) => breastCancerItemNameRegExp.test((product.name || '').toLowerCase()))

  if (breastCancerItemIndex > -1) {
    products[breastCancerItemIndex].withRibbonPopup = true
    return array.moveTo(products, breastCancerItemIndex, 0)
  }

  return array
}

const gqlFetch = ({ isBreastCancerEnabled }) => {
  // return requestNew('products', `{
  //   products(groups: ["PerfumeCase", "FragranceStorageBox", "CandleSet"], types: ["PerfumeCase", "FragranceStorageBox", "CandleSet"]) {
  //     id
  //     url
  //     sex
  //     img
  //     type
  //     name
  //     brand
  //     labels
  //     rating
  //     category
  //     price
  //     tradingItem {
  //       id
  //     }
  //   }
  // }`)

  return request.post('graphql?name=products', {
    body: {
      query: `{
        products(groups: ["PerfumeCase", "FragranceStorageBox", "CandleSet"], types: ["PerfumeCase", "FragranceStorageBox", "CandleSet"]) {
          id
          url
          sex
          img
          type
          name
          brand
          labels
          rating
          category
          price
          tradingItem {
            id
          }
        }
      }`,
    },
  })
    .then(({ products: items }) => {
      // TODO: Ask backends to move that logic to EXTRAS product feed
      let products = items
      const onTopNameRegExp = [
        /luxury candle set/,
        /scentbirdies/,
        /bottle galore/,
        /rack in white/,
        /rack in black/,
      ]

      onTopNameRegExp.reverse().forEach((regexp) => {
        const productIndex = products.findIndex((product) => regexp.test((product.name || '').toLowerCase()))

        if (productIndex > -1) {
          products = array.moveTo(products, productIndex, 0)
        }
      })

      if (isBreastCancerEnabled) {
        products = processBreastCancerItem(products)
      }

      products = products.map(({ tradingItem, ...item }) => ({
        ...item,
        tradingId: tradingItem && tradingItem.id, // it should be `tradingItem && tradingItem.id` coz there is `tradingItem: null` in response
      }))

      reducers.view.extrasPage.setItems(products)
    })
}

const restFetch = ({ isBreastCancerEnabled }) =>
  request.get('rest/engine/extras', {
    modifyResult: ({ items }) => items.map((item) => ({
      ...item,
      price: item.price * 100,
    })),
  })
    .then((items) => {
      let products = []

      const staticItems = [
        {
          id: 3,
          img: 'https://cdn.scentbird.com/ecommerce/extras/candle_set.jpg',
          name: 'Black&White Magic Luxury Candle Set',
          price: 1495,
        },
        {
          id: 921,
          img: 'https://cdn.scentbird.com/ecommerce/extras/scentbird_storage_box_white.jpg',
          name: 'Fragrance Storage Box "Scentbirdies"',
          price: 2495,
        },
        {
          id: 922,
          img: 'https://cdn.scentbird.com/ecommerce/extras/scentbird_storage_box_black.jpg',
          name: 'Fragrance Storage Box "Bottle Galore"',
          price: 2495,
        },
      ]

      products = [
        ...staticItems,
        ...items,
      ]

      if (isBreastCancerEnabled) {
        products = processBreastCancerItem(products)
      }

      reducers.view.extrasPage.setItems(products)
    })

const fetch = ({ isProductPageForExtrasEnabled, ...rest }) => (
  isProductPageForExtrasEnabled ? gqlFetch(rest) : restFetch(rest)
)


export default {
  fetch,
}
